// extracted by mini-css-extract-plugin
export var img = "intro-module--img--3aQYK";
export var title = "intro-module--title--MJzTU";
export var text = "intro-module--text--R4aIA";
export var disclaimer = "intro-module--disclaimer--1LsCS";